import React, { FC, useState } from 'react';
import { Box, CircularProgress } from '@mui/material';
import CssBaseline from '@mui/material/CssBaseline';
import NavHead from './NavHead';
import SideBar from './SideBar';
import clsx from 'clsx';
import useStyles from './style';

interface ILayout {
  children: React.ReactNode;
}

const Layout: FC<ILayout> = ({ children }) => {
  const classes = useStyles();
  const [drawerOpened, setDrawerOpened] = useState(false);
  const [loading, setLoading] = useState(false);

  return (
    <Box display="flex">
      <CssBaseline />
      <NavHead
        drawerOpened={drawerOpened}
        onOpenDrawer={() => setDrawerOpened(true)}
        setLoading={setLoading}
      />
      <SideBar
        drawerOpened={drawerOpened}
        onCloseDrawer={() => setDrawerOpened(false)}
        setLoading={setLoading}
      />

      {loading ? (
        <div className={classes.loaderContainer}>
          <CircularProgress size={80} thickness={4} />
        </div>
      ) : (
        <main
          className={clsx(
            classes.content,
            drawerOpened ? classes.contentShift : classes.contentUnshift
          )}
        >
          {children}
        </main>
      )}
    </Box>
  );
};

export default Layout;
